module.exports = "/dist/images/0879d3dede8c53c9c9cdaee329613c6b-gokhana-logo.png";